// extracted by mini-css-extract-plugin
export default {"CircledArrowTop":"styles_CircledArrowTop__A0bOg"};